<template>
  <div class="p-1">
    <div-table
      :config="configList"
      :data="credits"
      :idWharhouse="idWharhouse"
      :currentUser="currentUser"
      :limit="limit"
      :tabId="tabId"
      @reset="reset"
      @refresh="refresh"
      @filtrer="filtrer"
      @search="search"
      :loading="loading"
      :paginate="paginate"
      @paginatation="paginatation"
      @Changelimit="Changelimit"
      @getRowDetail="getRowDetail"
      @emtyTabId="emtyTabId"
      @selectAllCheckbox="selectAllCheckbox"
    >
    </div-table>
  </div>
</template>

<script>
import config from "./config";
export default {
  props: {
    currentUser: { type: Object },
    idWharhouse: { type: Object },
  },
  data() {
    return {
      configList: config.list,
      loading: false,
      formData: {},
      credits: [],
      tabId: [],
      limit: 10,
      filters: {},
      paginate: {
        total: 0,
        currentpage: 1,
        lastpage: 0,
        per_page: 0,
      },
    };
  },
  computed: {
    warhouseSelected() {
      return this.$store.getters["wharhouse/warhouseSelected"]({
        user: _.pick(this.currentUser, ["countries"]),
      });
    },
  },
  watch: {
    warhouseSelected: async function(oldVal, newVal) {},
    idWharhouse: async function(oldVal, newVal) {
      this.idWharhouse = oldVal;
      await this.reset();
    },
  },
  async mounted() {
    if (this.$f.QueryStringToobject())
      this.filters = this.$f.QueryStringToobject();
    else
      this.$f.objectToQueryString({
        limit: this.limit,
        "warehouse._id": this.idWharhouse._id,
      });

    if (this.filters.name) await this.search(this.filters.name);
    else await this.getAvoirs(this.filters);

    if (this.currentUser.type === "SourcingAtlas") {
      let pos1 = this.configList.columns
        .map(function(e) {
          return e.type;
        })
        .indexOf("checkbox");
      if (pos1 != -1) this.configList.columns.splice(pos1, 1);
    }

    this.setDataSelect("status", ["not applied", "applied"], null);
  },
  methods: {
    async getwharhouseId() {
      await this.$store
        .dispatch("wharhouse/getwharhouseId", {
          country: this.warhouseSelected,
        })
        .then((res) => {
          this.idWharhouse = res;
        });
    },
    setDataSelect(model, data, splice) {
      for (var i = 0; i < this.configList.filters.elements.champs.length; i++) {
        if (
          this.configList.filters.elements.champs[i].type === "select" &&
          this.configList.filters.elements.champs[i].key === model
        ) {
          if (!splice) {
            this.configList.filters.elements.champs[i].values = data;
          } else {
            this.configList.filters.elements.champs.splice(i, 1);
          }
        }
      }
    },
    async Changelimit(val) {
      if (this.$f.QueryStringToobject())
        this.filters = this.$f.QueryStringToobject();
      this.filters["limit"] = val;

      this.filters["page"] = 1;
      this.paginate.currentpage = 1;
      this.$f.objectToQueryString(this.filters);

      if (this.filters.name) await this.search(this.filters.name);
      else this.getAvoirs(this.filters);
    },
    getRowDetail(item, id) {
      const itemIndex = this.tabId.findIndex((i) => i.id === id);

      if (itemIndex !== -1) {
        // Item is already in tabId, remove it
        this.tabId.splice(itemIndex, 1);
      } else {
        // Item is not in tabId, add it
        this.tabId.push({
          id,
          code: item.code,
          warehouse: item.warehouse,
          service: item.service,
          amount: item.amount,
          method: item.method,
          status: item.status,
        });
      }
      
      if (this.tabId.length === 0) {
        document.querySelectorAll(".checkallbbox").forEach((column) => {
          column.checked = false;
        });
      }
    },
    selectAllCheckbox($event) {
      const isChecked = $event.target.checked;
      const columns = document.querySelectorAll(".rowCheckbox");
      
      this.tabId = isChecked ? [] : this.tabId;

      columns.forEach((column) => {
        column.checked = isChecked;
        if (isChecked) {
          const item = this.credits.find(credit => credit._id === column.id);
          if (item) {
            this.tabId.push({
              id: item._id,
              code : item.code,
              warehouse: item.warehouse,
              service: item.service,
              amount: item.amount,
              method: item.method,
              status: item.status
            });
          }
        }
      });

      if (!isChecked) {
        this.tabId = [];
      }
    },
    emtyTabId() {
      let columns = document.querySelectorAll(".rowCheckbox");
      columns.forEach((column) => {
        column.checked = false;
      });
      this.tabId = [];
    },
    async filtrer(data) {
      if (this.$f.QueryStringToobject())
        this.filters = this.$f.QueryStringToobject();

      delete this.filters.page;
      delete this.filters.name;

      this.paginate.currentpage = 1;
      if (!this.filters["limit"]) this.filters["limit"] = this.limit;

      if (data.status) {
        this.filters.status = data.status;
      } else delete this.filters.status;

      if (data.Range_date && data.Range_date[0]) {
        this.filters.Range_date = data.Range_date.map((el) =>
          this.$moment(el).format("yyyy-MM-DD")
        );
      } else delete this.filters.Range_date;

      this.$f.objectToQueryString(this.filters);
      await this.getAvoirs(this.filters);
    },
    // User and Status
    async getUser() {
      const res = await this.$me;
      this.currentUser = res.content;
    },
    async reset() {
      this.emtyTabId();

      let lmitt = this.limit;
      if (this.$f.QueryStringToobject())
        this.filters = this.$f.QueryStringToobject();
      if (this.filters["limit"]) lmitt = this.filters["limit"];

      this.filters["page"] = 1;
      this.$f.objectToQueryString({
        limit: lmitt,
        "warehouse._id": this.idWharhouse._id,
      });

      await this.getAvoirs({ limit: lmitt });
    },
    async refresh() {
      this.emtyTabId();

      if (this.$f.QueryStringToobject())
        this.filters = this.$f.QueryStringToobject();
      this.$f.objectToQueryString(this.filters);

      if (this.filters.name) await this.search(this.filters.name);
      else await this.getAvoirs(this.filters);

      if (
        this.filters["page"] &&
        this.filters["page"] > 1 &&
        this.credits.length == 0
      ) {
        this.filters["page"] = --this.filters["page"];
        this.$f.objectToQueryString(this.filters);
        await this.getAvoirs(this.filters);
      }
    },
    async getAvoirs(filters) {
      this.loading = true;
      filters["warehouse._id"] = this.idWharhouse._id;

      const res = await this.$server.search("credits", filters);
      this.loading = false;

      if (res && res.content.results) {
        this.credits = res.content.results;
        this.credits.forEach(
          function(avoir) {
            if (avoir.payment && avoir.status === "applied") {
              avoir.payment =
                `<a class="text-blue-600" target="_blank" href="/credits/detail/${avoir._id}">
                  <svg class="fill-current" width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd">
                    <path d="M14 4h-13v18h20v-11h1v12h-22v-20h14v1zm10 5h-1v-6.293l-11.646 11.647-.708-.708 11.647-11.646h-6.293v-1h8v8z"/>
                  </svg>
                </a>`;
              ;
            }
          }.bind(this)
        );
        this.paginate.total = res.content.total;
        this.paginate.lastpage = res.content.last_page;

        this.paginate.per_page = res.content.per_page;
        this.paginate.currentpage = res.content.current_page;
      } else {
        this.credits = [];
        this.paginate = { total: 0, currentpage: 1, lastpage: 1, per_page: 0 };
      }
    },
    async search(data) {
      this.paginate = { total: 0, currentpage: 1, lastpage: 1, per_page: 0 };
      let limitt = this.limit;

      if (this.filters["limit"]) limitt = this.filters["limit"];
      const search = {
        name: data.trim(),
        limit: parseInt(limitt),
        "warehouse._id": this.idWharhouse._id,
      };

      this.$f.objectToQueryString(search);
      const res = await this.$server.find("credits", search);

      if (res.content.results) {
        this.credits = res.content.results;
        this.credits.forEach(
          function(avoir) {
            if (avoir.payment && avoir.status === "applied") {
              avoir.payment =
              `<a class="text-blue-600" target="_blank" href="/credits/detail/${avoir._id}">
                  <svg class="fill-current" width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd">
                    <path d="M14 4h-13v18h20v-11h1v12h-22v-20h14v1zm10 5h-1v-6.293l-11.646 11.647-.708-.708 11.647-11.646h-6.293v-1h8v8z"/>
                  </svg>
                </a>`;
            }
          }.bind(this)
        );

        this.paginate.total = res.content.total;
        this.paginate.lastpage = res.content.last_page;

        this.paginate.per_page = res.content.per_page;
        this.paginate.currentpage = res.content.current_page;
      } else {
        this.credits = [];
        this.paginate = { total: 0, currentpage: 1, lastpage: 1, per_page: 0 };
      }
    },
    async remove(id) {
      this.$confirm("You want to delete this avoir?").then(async (res) => {
        if (res) {
          const resp = await this.$server.delete("credits", { id: id });
          await this.refresh();
          alert("avoir Deleted", "success");
        }
      });
    },
    async paginatation(direction) {
      var page = 0;
      if (direction == "next") {
        page = ++this.paginate.currentpage;
      } else {
        page = --this.paginate.currentpage;
      }

      if (this.$f.QueryStringToobject())
        this.filters = this.$f.QueryStringToobject();
      this.filters["page"] = page;
      this.$f.objectToQueryString(this.filters);

      this.getAvoirs(this.filters);
    },
  },
};
</script>

<style>
.border-top {
    border-top: 2px dashed #8d9091 !important;
}

.border-left-dashed {
    border-left: 2px dashed #8d9091;
}
</style>
